import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { Querystring } from 'utils/url';

const { CAMPAIGN_DASHBOARD } = API.END_POINTS;

const STATISTICS_CREATOR_LOADING = 'campaignDashboardStatistics/CREATOR_LOADING';
const STATISTICS_CREATOR_LOADED = 'campaignDashboardStatistics/CREATOR_LOADED';
const STATISTICS_CREATOR_RESET = 'campaignDashboardStatistics/CREATOR_RESET';
const STATISTICS_AUDIENCE_LOADING = 'campaignDashboardStatistics/AUDIENCE_LOADING';
const STATISTICS_AUDIENCE_LOADED = 'campaignDashboardStatistics/AUDIENCE_LOADED';
const STATISTICS_AUDIENCE_RESET = 'campaignDashboardStatistics/AUDIENCE_RESET';

import type {
  Action,
  CampaignStatistics,
  ChartType,
  Dispatch,
  ThunkAction
} from 'types';

const initialState = {
  statistics: {
    creator: {},
    audience: {}
  },
  isLoading: {
    creator: false,
    audience: false
  }
};

const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,

  payload: {
    status
  }
});

const statisticsLoaded = (type: string, statistics: CampaignStatistics): Action => ({
  type,

  payload: {
    statistics
  }
});

export const resetCampaignDashboardStatistics = (chartType: ChartType): Action => {
  const actionType = chartType === 'creator' ? STATISTICS_CREATOR_RESET : STATISTICS_AUDIENCE_RESET;

  return {
    type: actionType
  };
};

export const fetchCampaignDashboardStatistics = (chartType: ChartType, campaignId: number, filter: string, channel?: string): ThunkAction => {
  const actionTypeLoading = chartType === 'creator' ? STATISTICS_CREATOR_LOADING : STATISTICS_AUDIENCE_LOADING;
  const actionTypeLoaded = chartType === 'creator' ? STATISTICS_CREATOR_LOADED : STATISTICS_AUDIENCE_LOADED;

  return async (dispatch: Dispatch) => {
    dispatch(setLoadingStatus(actionTypeLoading, true));

    try {
      const queryString = Querystring.objectToString({
        offer_state: filter !== 'all' ? filter : undefined,
        channel
      });
      const url = CAMPAIGN_DASHBOARD.getStatistics(chartType, campaignId, queryString);
      const response = await get(url);
      const statistics = response.data || {};

      dispatch(statisticsLoaded(actionTypeLoaded, statistics));
      dispatch(setLoadingStatus(actionTypeLoading, false));
    } catch (e) {
      dispatch(setLoadingStatus(actionTypeLoading, false));
      logError(e);
    }
  };
};

export default createReducer<any, any>('campaignDashboardStatistics', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [STATISTICS_CREATOR_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: {
      ...state.isLoading,
      creator: status
    }
  }),
  [STATISTICS_CREATOR_LOADED]: (state, { statistics }) => ({
    ...state,
    statistics: {
      ...state.statistics,
      creator: statistics
    }
  }),
  [STATISTICS_CREATOR_RESET]: (state) => ({
    ...state,
    statistics: {
      ...state.statistics,
      creator: {}
    }
  }),
  [STATISTICS_AUDIENCE_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: {
      ...state.isLoading,
      audience: status
    }
  }),
  [STATISTICS_AUDIENCE_LOADED]: (state, { statistics }) => ({
    ...state,
    statistics: {
      ...state.statistics,
      audience: statistics
    }
  }),
  [STATISTICS_AUDIENCE_RESET]: (state) => ({
    ...state,
    statistics: {
      ...state.statistics,
      audience: {}
    }
  })
});
